export {
  createAssistantClient,
  AssistantError,
} from './client';

export type {
  AssistantConfig,
  AssistantClient,
  AssistantAccount,
  AssistantThread,
  AssistantMessage,
  AssistantEvent,
  LoginStart,
} from './client';

export { useAssistantThread } from './useAssistantThread';
export type { UiMessage, UseAssistantThreadOptions } from './useAssistantThread';

export { useAssistantAccount, PROVIDER_LABEL, PROVIDER_MODELS } from './useAssistantAccount';
export type { UseAssistantAccountOptions } from './useAssistantAccount';
